import { selectBoundArtifactProjection } from './artifactBindingProjection.js';

/** Missing canonical projection is empty; history and templates cannot supply live truth. */
export function selectCurrentIntakeCanvasProjection({ sessionContext = {}, canvasActiveTabKey } = {}) {
  return selectBoundArtifactProjection(sessionContext, canvasActiveTabKey) ?? {
    content: '', artifact_document: {}, progress: null, collected: [], candidate_fields: [], missing: [],
    versions: [], revision_controls: {}, current_question: {}, readiness: {}, next_actions: [],
    workspace_capabilities: {}, field_definitions: [], has_intake_canvas_state: false,
    ui_signal: {}, signal_id: '',
  };
}

export default selectCurrentIntakeCanvasProjection;
